export default "__VITE_ASSET__B7O4z_KW__"